window.GIFTBOX_CUSTOM_CART_ITEMS_SELECTORS = [".cart-item"]

window.GIFTBOX_CUSTOM_CART_REMOVE_LINK_SELECTORS = [".cart-item__description a"]

window.GIFTBOX_CUSTOM_CART_REMOVE_INPUTS_SELECTORS = [".quantity"]


const GBintSection = setInterval(() => {
    const section = document.querySelector('[id*="shopify-section-template"][id*="__main"]')
    if(section) {
        console.log(section.id)
        section.id = section.id.replace("section", "sections")
        clearInterval(GBintSection)
    }
})